// Bouton « Apple Pay » aux couleurs de la boutique, posé sur le vrai bouton Apple Pay de Shopify
// (invisible, par-dessus : c'est lui que le client touche). Notre bouton ne s'affiche que si
// Shopify a réellement fourni Apple Pay sur cet appareil.
// Le bouton officiel garde sa taille et son fonctionnement d'origine ; on l'étire seulement par
// transform pour qu'il recouvre toute la surface de notre bouton (sinon seul le milieu répondait).
(function () {
  const ajuster = (bloc) => {
    const officiel = bloc.querySelector('shopify-apple-pay-button');
    const bouton = bloc.querySelector('[data-mp-applepay-bouton]');
    if (!officiel || !bouton || bloc.hidden) return;
    officiel.style.transform = '';
    const a = officiel.getBoundingClientRect();
    const b = bouton.getBoundingClientRect();
    if (!a.width || !a.height || !b.width || !b.height) return;
    officiel.style.transformOrigin = '0 0';
    officiel.style.transform =
      `translate(${b.left - a.left}px, ${b.top - a.top}px) scale(${b.width / a.width}, ${b.height / a.height})`;
  };

  const preparer = (bloc) => {
    const aApplePay = !!bloc.querySelector('shopify-apple-pay-button');
    if (bloc.hidden === aApplePay) bloc.hidden = !aApplePay;
    if (!aApplePay) return;
    if (!bloc.mpObservateur && 'ResizeObserver' in window) {
      bloc.mpObservateur = new ResizeObserver(() => ajuster(bloc));
      bloc.mpObservateur.observe(bloc);
    }
    requestAnimationFrame(() => ajuster(bloc));
  };

  let enAttente = false;
  const tout = () => {
    if (enAttente) return;
    enAttente = true;
    requestAnimationFrame(() => {
      enAttente = false;
      document.querySelectorAll('[data-mp-applepay]').forEach(preparer);
    });
  };
  tout();
  // Les boutons de Shopify arrivent après le chargement, et le tiroir panier est re-rendu
  new MutationObserver(tout).observe(document.body, { childList: true, subtree: true });
  // Tiroir ouvert : les dimensions changent
  document.addEventListener('click', () => setTimeout(tout, 400));
})();
